import styled from 'styled-components';
import { select } from '@panel/commons/core/themev2';

const TableContainer = styled.div`
  width: 100%;
  margin-top: ${({ device }) => (device !== 'desktop' ? 20 : 30)}px;
  display: flex;
  max-height: ${({ device }) => (device !== 'mobile' ? '700px' : '500px')};
  border: 1px solid ${select('middleGray')};
  border-radius: 8px;
`;

const Td = styled.td`
  padding-left: 43px;
  width: auto;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  label {
    margin-left: 32% !important;
  }

  :first-child {
    width: 54%;
  }
`;

const NameContainer = styled.div`
  width: auto;
`;

const SwitchContainer = styled.div`
  width: auto;
  display: flex;
  gap: 14px;
  padding-left: 16px;
`;

const SpanResponsible = styled.span`
  width: auto;
  padding-left: 8px;
  color: ${select('midDarkGray')};
  font-family: Hind;
  font-size: ${({ device }) => (device !== 'desktop' ? '12px' : '16px')};
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

const StyledAction = styled.div`
  background-image: ${({ icon }) => `url(${icon})`};
  opacity: ${({ disabled }) => (disabled ? 0.25 : 1)};
  width: 40px;
  height: 40px;
  background-repeat: no-repeat;
  background-position: center;
  border-radius: 50%;
  margin-top: ${({ device }) => {
    if (device === 'tablet') return '12%';
    if (device === 'mobile') return '16%';
    return '18px';
  }};
  margin-left: ${({ device }) => (device !== 'desktop' ? '10%' : '0')};
  background-size: ${({ backSize }) => backSize};
  @media (min-width: 821px) and (max-width: 1181px) {
    margin-top: 12px;
    margin-left: 0;
  }
`;

const TooltipComponent = styled.div`
  width: 200px;
  white-space: pre-wrap;
  padding: 3px 0;
`;

const AlertContainer = styled.div`
  width: 100%;
  margin-top: ${({ device }) => (device !== 'desktop' ? 20 : 30)}px;
`;

const FooterContainer = styled.div`
  position: absolute;
  width: 100%;
  left: 0;
  margin-top: 20px;
  display: ${({ device }) => (device === 'mobile' ? 'inline-flex' : 'none')};
  height: 119px;
  padding: 16px 42px 84px 42px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  background: ${select('lightGray')};
  color: ${select('grayDarkLight')};
  font-size: 12px;
`;

export {
  TableContainer,
  Td,
  NameContainer,
  SpanResponsible,
  StyledAction,
  SwitchContainer,
  TooltipComponent,
  AlertContainer,
  FooterContainer
};
